module.exports = __webpack_public_path__ + "static/media/poweredby.2ac8aaf5.svg";